// Patch for useAppBuilderSettings to support CORS handling
// This patches the shared component until we can commit changes to the submodule

import {fetchThemeFile} from "../utils/corsProxy";

/**
 * Patch the fetch call in useAppBuilderSettings to use CORS-aware fetching
 */
export function patchThemeFetch() {
	// Store the original fetch to avoid infinite recursion
	const originalFetch = window.fetch;

	// Track if we're already processing a theme request to prevent infinite loops
	let isProcessingTheme = false;

	window.fetch = function (input: RequestInfo | URL, init?: RequestInit) {
		const url = typeof input === "string" ? input : input.toString();

		// If this is a theme file request and we're not already processing one
		if (
			url.includes("theme") &&
			url.includes(".json") &&
			!isProcessingTheme
		) {
			console.log("Intercepting theme file request:", url);
			isProcessingTheme = true;

			return fetchThemeFile(url, originalFetch)
				.then((data) => {
					isProcessingTheme = false;
					return new Response(JSON.stringify(data), {
						status: 200,
						statusText: "OK",
						headers: {"Content-Type": "application/json"},
					});
				})
				.catch((error) => {
					isProcessingTheme = false;
					console.error("Theme fetch failed:", error);
					// Return empty theme as fallback
					return new Response(JSON.stringify({}), {
						status: 200,
						statusText: "OK",
						headers: {"Content-Type": "application/json"},
					});
				});
		}

		// Otherwise use original fetch
		return originalFetch.call(this, input, init);
	};
}

// Initialize the patch
if (typeof window !== "undefined") {
	patchThemeFetch();
}
